var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{style:({ 'margin-bottom': _vm.marginBottom, 'margin-top': _vm.marginTop })},[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }